module.exports = __webpack_public_path__ + "static/media/riskcase4.c0af86f8.png";